import {
  createSelfOperatedShop,
  getShopSimpleList
} from '@/api/merchant/shop-manager'

/** 平台自营 shop_type=1 */
export const MALL_SELF_OPERATED_SHOP_TYPE = 1

export type MallSelfOperatedShop = {
  id: number
  name: string
  shopType?: number
}

/**
 * 确保当前租户至少有一家自营店；若无则自动创建「平台自营店」。
 * 用于自营视角冷启动：侧栏已藏「店铺管理」，不能再依赖手工建店。
 * P3.1：外部自营开通时服务端已 ensure；此处保留作兜底（无权限/历史会话）。
 * @returns 自营店列表（至少 0；无权限建店时可能仍为空）
 */
export async function ensureDefaultSelfOperatedShops(
  defaultName = '平台自营店'
): Promise<MallSelfOperatedShop[]> {
  const raw = (await getShopSimpleList({ shopType: MALL_SELF_OPERATED_SHOP_TYPE })) || []
  let list: MallSelfOperatedShop[] = raw.map((s: any) => ({
    id: Number(s.id),
    name: s.name || `店铺${s.id}`,
    shopType: s.shopType ?? MALL_SELF_OPERATED_SHOP_TYPE
  }))
  if (list.length > 0) {
    return list
  }
  try {
    const id = await createSelfOperatedShop({
      shopName: defaultName,
      shopDesc: '系统为自营模式自动创建的默认店铺壳，用于发品与货池挂店'
    })
    if (id) {
      list = [
        {
          id: Number(id),
          name: defaultName,
          shopType: MALL_SELF_OPERATED_SHOP_TYPE
        }
      ]
    }
  } catch {
    // 无 merchant:shop:create 等权限时保持空列表，由页面提示
  }
  return list
}

/** 仅一家自营店时取默认 id（多店仍须手动选） */
export function pickDefaultSelfOperatedShopId(
  shops: MallSelfOperatedShop[]
): number | undefined {
  if (shops.length !== 1) {
    return undefined
  }
  return shops[0].id
}
